import client from "../api/client";

/**
 * In-app path of the standalone doc viewer for an uploaded submission file.
 * Meant for a new tab (`<a target="_blank">`): the page re-fetches the file
 * through the authenticated API using the token already in localStorage.
 * The file name only drives type detection / display, so it rides in the query.
 */
export function submissionViewerPath(submission) {
  const query = submission?.file_original_name
    ? `?name=${encodeURIComponent(submission.file_original_name)}`
    : "";
  return `/dashboard/submissions/${submission.id}/view${query}`;
}

/**
 * Download an uploaded submission file through the authenticated, forced-download
 * API route. `submission.file_download_url` is an absolute URL from the backend;
 * we hit it with the axios client so the bearer token is attached, then hand the
 * blob to the browser as a save.
 */
export async function downloadSubmissionFile(submission) {
  if (!submission?.file_download_url) return;

  const name =
    submission.file_original_name ||
    submission.file_download_url.split("/").pop() ||
    "submission";

  const { data } = await client.get(submission.file_download_url, {
    responseType: "blob",
    baseURL: "", // file_download_url is already absolute
  });

  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  a.click();
  URL.revokeObjectURL(href);
}
